/*
 * @Author: meixianming
 * @Date: 2022-06-05 22:33:55
 * @LastEditors: meixianming
 * @LastEditTime: 2022-06-05 22:33:58
 * @Description: vue 通信bus
 * @FilePath: /unidt/src/bus.js
 */
import Vue from "vue"

export default new Vue()



// WEBPACK FOOTER //
// ./src/bus.js